import { ControlledModbusTcpPUTDto } from 'src/Libs/flow/end-user-settings'
import { sanitizeToLatin } from 'src/Libs/flow/installation/utils/sanitize-to-latin'
import { wittyFlexReference, mapModbusReferenceToWbType } from 'src/Libs/wallboxes/models/wallbox-reference'
import { getSunMode } from './sun-mode'
import { ModbusTcpChargingStation } from 'src/Libs/flow/installation/forms'
import { getChargeInFallbackModeAllowed, getMidMeterParameters } from './modbus-tcp-helpers'

export const getModbusTcpPUTDto = (modbusTcp: ModbusTcpChargingStation): ControlledModbusTcpPUTDto => {
  /** If deviceReference starts with "XVL122C", the cable if always locked by the config. */
  const lockCable: boolean = modbusTcp.deviceReference?.startsWith('XVL122C') ? true : modbusTcp.isCableLocked

  const isWittyFlex = modbusTcp.reference === wittyFlexReference

  return {
    deviceName: sanitizeToLatin(modbusTcp.name),
    parameters: {
      protection: modbusTcp.protection || 0,
      minCurrent: modbusTcp.minCharge || 0,
      phasesManagement: isWittyFlex ? null : modbusTcp.phaseManagement,
      phaseMapping: modbusTcp.phaseMapping,
      ledIntensity: modbusTcp.ledIntensityPercentage || 0,
      activated: modbusTcp.rawData?.parameters?.activated ?? false,
      authenticationMode: modbusTcp.accessManagementOptions,
      fallbackMaxCurrent: modbusTcp.fallbackMaxCurrent || 0,
      minCurrentSunMode: modbusTcp.solarRatio || 0,
      priority: modbusTcp.rawData?.parameters?.priority ?? 100,
      chargeInFallbackModeAllowed: getChargeInFallbackModeAllowed(modbusTcp.fallbackMaxCurrent),
      lockCable: isWittyFlex ? undefined : lockCable,
      ...getMidMeterParameters(modbusTcp),
      sunMode: getSunMode(modbusTcp.holdingTime || 0, modbusTcp.chargingMode, modbusTcp.safePvSchedule, modbusTcp.efficientPvSchedule),
    },
    evseSubTypeParameters: {
      ocppActivation: modbusTcp.carAtHomeBehavior.isEnabled,
      ocppServerAddress: modbusTcp.carAtHomeBehavior.chargingPointOperatorWs,
      ocppId: modbusTcp.carAtHomeBehavior.ocppId,
      ocppAuthType: modbusTcp.carAtHomeBehavior.isCredentialsActive ? 'basic' : 'No',
      deviceReference: modbusTcp.deviceReference,
      wbType: mapModbusReferenceToWbType(modbusTcp.reference),
    },
  }
}
